import React, { useState } from 'react';

const BackendSelector = ({ value, onChange, disabled = false }) => {
  const [showInfo, setShowInfo] = useState(false);

  const backends = [
    {
      value: 'traditional',
      name: '⚡ Traditional LLM',
      description: 'Fast, simple, cost-effective'
    },
    {
      value: 'strands',
      name: '🤖 Multi-Agent Strands',
      description: 'Comprehensive, expert analysis'
    }
  ];

  return (
    <div className="backend-selection">
      <label className="backend-label">Select Backend Architecture:</label>
      <div className="backend-options">
        {backends.map(backend => (
          <label key={backend.value} className="backend-option">
            <input
              type="radio"
              value={backend.value}
              checked={value === backend.value}
              onChange={(e) => onChange(e.target.value)}
              disabled={disabled}
            />
            <span className="backend-name">{backend.name}</span>
            <span className="backend-desc">{backend.description}</span>
          </label>
        ))}
        
        <button 
          type="button"
          className="compare-btn"
          onClick={() => setShowInfo(!showInfo)}
        >
          i
        </button>
      </div>
      
      {showInfo && (
        <div className="backend-info">
          <h4>Architecture Comparison:</h4>
          <div className="comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>⚡ Traditional</th>
                  <th>🤖 Strands</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Speed</strong></td>
                  <td>Fast (20-30s)</td>
                  <td>Slower (60-90s)</td>
                </tr>
                <tr>
                  <td><strong>Cost</strong></td>
                  <td>Low (~$0.05-0.10)</td>
                  <td>Higher (~$0.20-0.40)</td>
                </tr>
                <tr>
                  <td><strong>Quality</strong></td>
                  <td>Good</td>
                  <td>Excellent</td>
                </tr>
                <tr>
                  <td><strong>Approach</strong></td>
                  <td>Direct LLM calls</td>
                  <td>Specialist agents</td>
                </tr>
                <tr>
                  <td><strong>Perspectives</strong></td>
                  <td>Single model</td>
                  <td>Multiple experts</td>
                </tr>
                <tr>
                  <td><strong>Best For</strong></td>
                  <td>Quick analysis, prototypes</td>
                  <td>Production, comprehensive reports</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="backend-note">
            <strong>💡 Tip:</strong> Start with Traditional for quick tests, 
            use Strands for final comprehensive reports.
          </p>
        </div>
      )}
    </div>
  );
};

export default BackendSelector;
